import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  // Custom header forces a CORS preflight, blocking cross-site (CSRF) writes.
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

export default api;
